<template>
  <div id="login" class="card">
    <div class="card-body">
      <div class="text-center mb-4 mt-1">
        <img alt="Vue logo" height="60" src="../../../assets/logo-rentik.svg">
      </div>
      <form @submit.prevent="submit()">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="user">Nombre de usuario</label>
              <input type="text" class="form-control" id="user" v-model.trim="v$.user.$model">
              <div v-if="v$.user.$dirty">
                <small class="form-text text-danger" v-if="!v$.user.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-primary" v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid">
              <span v-if="!loading">Continuar</span>
              <img v-if="loading" src="../../../assets/loader.svg" height="20" alt="">
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <InfoOTP :id="'modalInfo'" :modalTitle="'CÓDIGO DE CONFIRMACIÓN ENVIADO'" :showFooter="false">
  </InfoOTP>
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { Modal as ModalBootstrap } from "bootstrap";
import InfoOTP from './templates/InfoOTP.vue'
import axios from 'axios';
import ModalError from '../Shared/ModalError.vue'

export default {
  name: 'GetOTP',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    InfoOTP,
    ModalError
  },
  data() {
    return {
      user: '',
      loginError: false,
      loading: false,
      errorMessage: '',
      errorCode: '',
    };
  },
  validations() {
    return {
      user: {
        required
      },
    }
  },

  methods: {
    submit() {
      this.loading = true;
      const bodyToSend = {
        username: this.user,
        userType: "BACKOFFICE"
      }
      axios.post('/user/resetPassword', bodyToSend)
        .then((response) => {
          console.log(response);
          this.$cookies.set('username', this.user)
          var myModal = new ModalBootstrap(document.getElementById('modalInfo'))
          myModal.show()
        })
        .catch((error) => {
          this.errorCode = error.response.data.code
          this.errorMessage = error.response.data.message
          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show()
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-login {
  min-width: 120px;
}
</style>
